import { render, staticRenderFns } from "./SchlagwoerterComponent.vue?vue&type=template&id=0693439e&scoped=true"
import script from "./SchlagwoerterComponent.vue?vue&type=script&lang=js"
export * from "./SchlagwoerterComponent.vue?vue&type=script&lang=js"
import style0 from "./SchlagwoerterComponent.vue?vue&type=style&index=0&id=0693439e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0693439e",
  null
  
)

export default component.exports